//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Price',
  props: {
    discountPercent: {
      type: Number,
      default: 0,
    },
    price: {
      type: String,
      default: '',
    },
    installmentPlan: {
      type: Number,
      default: 0,
    },
    installmentPrice: {
      type: String,
      default: '',
    },
  },
};
